import styled from 'styled-components';
import uniqueId from 'lodash/uniqueId';
import JobTeaser from '../../../molecules/JobTeaser';
import { JobTeaserLink } from '../../../molecules/JobTeaser/JobTeaserLink';

const TeaserOverviewContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const JobTeaserStyled = styled(JobTeaser)`
  width: calc(50% - 2px);
  min-height: 250px;
  flex-grow: 1;
  flex-basis: auto;
  flex-shrink: 0;
  position: relative;
  &:nth-child(odd) {
    margin-right: 2px;
  }
  &:nth-child(even) {
    margin-left: 2px;
  }
  margin-bottom: 4px;
`;

/**
 * @param {JobTeaserOverviewProps} props
 */
const JobTeaserOverviewDesktop = ({ teasers, format = 'TEASERS' }) => {
  return (
    <TeaserOverviewContainer>
      {teasers.map((teaser) =>
        format === 'TEASERS' ? (
          <JobTeaserStyled key={uniqueId('jobTeaser')} {...teaser} />
        ) : (
          <JobTeaserLink key={uniqueId('jobTeaserLink')} {...teaser} />
        ),
      )}
    </TeaserOverviewContainer>
  );
};

export default JobTeaserOverviewDesktop;
